<div class="row content" *ngIf="info && info.cancelled_reason">
  <div class="form-group col-md-12">
    <label [class.required]="true">{{'Reason for Rejection' | translate}}</label>
    <textarea
      class="form-control"
      rows="3"
      [value]="info.cancelled_reason"
      disabled
    ></textarea>
  </div>
  <div class="col-md-8">
    <label>{{'Rejected By' | translate}}</label>
    <div class="text-value">{{ info.verification_name }}</div>
  </div>
  <div class="col-md-4">
    <label>{{'Rejected On' | translate}}</label>
    <div class="text-value">{{ info.modified_date | date: 'dd-MMM-yyyy' }}</div>
  </div>
</div>
